import { parseSearch, stringifySearch } from '@blockit/web-shared/router/searchCodec';
import { createRouter } from '@datadog/browser-rum-react/tanstack-router';
import type { DemoSignUpLocationState } from '@features/onboarding/types';
import { routeTree } from '@/routeTree.gen';

export const router = createRouter({
  routeTree,
  // OAuth callbacks hand `code` and `state` back verbatim; TanStack's JSON codec would read `?code=123` as a number.
  parseSearch,
  stringifySearch,
  // Hovering a link fetches its page's chunk, so the click doesn't wait on the download.
  defaultPreload: 'intent',
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }

  interface HistoryState extends Partial<DemoSignUpLocationState> {
    fromDashboard?: boolean;
    initialMessage?: string;
    initialAttachments?: File[];
  }
}
